import angular from 'angular';

import { CatalogsController } from './catalogs.controller';
import { CatalogsService } from './catalogs.service';

angular
  .module('parameters.catalogs', [])
  .controller('CatalogsController', CatalogsController)
  .factory('CatalogsFactory', CatalogsService.CatalogsFactory);